import { Component, OnInit, HostListener, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-choosepayment-modal',
  templateUrl: './choosepayment-modal.component.html',
  styleUrls: ['./choosepayment-modal.component.css']
})
export class ChoosepaymentModalComponent implements OnInit {
  @Output() modeSelected: EventEmitter<any> = new EventEmitter<any>();
  options = [{"name": "Pay now using Credit/Debit card", "value": "stripe"},
            {"name": "Pay later using invoice", "value": "xero"}];

  selectedMode = "stripe";

  @HostListener('document:keyup', ['$event']) keyups(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      this.cancel();
    }
  }

  constructor() { }

  ngOnInit() {
  }

  openModal() {
    $("#paymentModeModal").modal('show');
  }

  proceedPayment() {
    if (this.selectedMode) {
      this.cancel();
      this.modeSelected.emit(this.selectedMode);
    }
  }

  cancel() {
    $(".modal-backdrop").hide();
    $(".modal-open").css('overflow', 'auto');
    $("#paymentModeModal").modal('hide');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/choosepayment-modal/choosepayment-modal.component.ts